import React from "react";
import { packClasses } from "Utils";

export default function Pill({ label, className, children, ...remainder }) {
    let myClasses =
        "inline-flex items-center py-1 px-2 rounded-md text-xs font-light";

    return (
        <span
            className={packClasses(
                className ? className : "bg-gray-100 text-gray-700",
                myClasses
            )}
        >
            {children ? children : label}
        </span>
    );
}
